import { css, cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';

const title = css`
  flex-grow: 1;
  flex-basis: 100%;
`;

const root = css`
  width: 100%;
  display: flex;
  flex-direction: row;
  font-family: inherit;
  font-size: inherit;
  text-align: left;
  background-color: transparent;
  border-width: 0;
  outline: 0;
  cursor: pointer;
  padding: ${cssTheme.gu2} 0;
  color: currentColor;
  transition: padding-bottom var(--transition-duration) ease-in-out;

  &:not(:focus-visible) {
    outline: 0;
  }
  
  ${cssTheme.breakpoints.lg} {
    padding: ${cssTheme.gu3} 0;
  }
`;

const icon = css`
  margin-left: ${cssTheme.gu1};
  width: ${cssTheme.gu3};
`;

const active = css`
  padding-bottom: ${cssTheme.gu1}
`;

export const getClassNames = ({ isActive }: { isActive?: boolean }) => {
  return {
    root: cx(root, isActive && active),
    title,
    icon,
  };
};